import {mapState} from "vuex";

import {stripTags} from "@/filters/stripTags";
import {currentLocale} from "@/filters/currentLocale";

export default {
  computed: {
    ...mapState(['customer', 'mainConfig']),
  },
  methods: {
    getLotSortComparator(a, b) {
      if (!this.mainConfig.sortByOutbidFirstInMyBids) {
        return -1;
      }

      const aOutbid = a.has_my_bid && !this.isCurrentUserLastBidder(a);
      const bOutbid = b.has_my_bid && !this.isCurrentUserLastBidder(b);

      if (aOutbid && !bOutbid) {
        return -1
      } else if (!aOutbid && bOutbid) {
        return 1
      }

      // Sort by title
      const titleA = stripTags(currentLocale(a.title)).toLowerCase();
      const titleB = stripTags(currentLocale(b.title)).toLowerCase();

      if (titleA < titleB) {
        return -1
      } else if (titleA > titleB) {
        return 1
      }
      return 0
    },
    isCurrentUserLastBidder(lot) {
      if (this.customer?.uuid && lot.winning_bid?.customer_uuid) {
        return this.customer.uuid === lot.winning_bid.customer_uuid;
      }
      return false;
    }
  }
}
